import React, { createContext, FC, useEffect, useState } from 'react'
import { en_US_translations_fallback } from '@util/i18n/en_US'

interface I18nContextState {
  translations: {
    [key: string]: any
  }
  selectedLanguage: string
  setSelectedLanguage: Function
  setTranslations: Function
}

export const defaultI18nContext = {
  translations: {
    en: { translation: en_US_translations_fallback },
  },
  selectedLanguage: 'en',
  setSelectedLanguage: () => {},
  setTranslations: () => {},
}

export const TranslationsContext =
  createContext<I18nContextState>(defaultI18nContext)

export const TranslationProvider: FC = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    localStorage.getItem('ThriveWebApp_SelectedLanguage') ||
      defaultI18nContext.selectedLanguage
  )
  const [translations, setTranslations] = useState(() => {
    const storedTranslations = localStorage.getItem('ThriveWebApp_Translations')
    if (storedTranslations) {
      return JSON.parse(storedTranslations)
    } else {
      return defaultI18nContext.translations
    }
  })

  useEffect(() => {
    localStorage.setItem('ThriveWebApp_SelectedLanguage', selectedLanguage)
  }, [selectedLanguage])

  useEffect(() => {
    localStorage.setItem(
      'ThriveWebApp_Translations',
      JSON.stringify(translations)
    )
  }, [translations])

  return (
    <TranslationsContext.Provider
      value={{
        selectedLanguage,
        setSelectedLanguage,
        translations,
        setTranslations,
      }}
    >
      {children}
    </TranslationsContext.Provider>
  )
}
